export const visit = (vm, at) => {
at({ "da": { "conversations-visitor-experience-components": { "code-splitting": { "error": { "title": "Der var et problem med netv\xE6rksforbindelsen.", "message": "Kontroll\xE9r din forbindelse, og pr\xF8v igen.", "button": "Pr\xF8v igen" } } } } });
};